import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const initI18n = async (supportedLocales: string[]) => {
  await i18n
    // https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    .use(initReactI18next)
    // https://www.i18next.com/overview/configuration-options
    .init({
      fallbackLng: 'en',
      debug: process.env.NODE_ENV === 'development',
      supportedLngs: supportedLocales,
      load: 'languageOnly',
      interpolation: { escapeValue: false }, // not needed for react as it escapes by default
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
      detection: {
        // IMPROVED LANGUAGE DETECTION ORDER:
        // This order was optimized to fix language detection issues.
        // Each method is tried in sequence until a supported language is found.
        order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],

        // ORIGINAL (had issues): order: ['querystring', 'navigator'],
        // Problems with original:
        // - Too restrictive, missing localStorage/cookie persistence
        // - No fallback mechanisms beyond navigator
        // - Language choice wasn't cached between sessions

        // LANGUAGE PERSISTENCE:
        // Cache detected language in both localStorage and cookies for persistence
        caches: ['localStorage', 'cookie'],
        // ORIGINAL (caused issues): caches: [],
        // Problem: Language detection happened every time, no persistence

        excludeCacheFor: ['cimode'], // Don't cache development/test languages

        // DETECTION METHOD CONFIGURATION:
        lookupQuerystring: 'lng', // ?lng=sv
        lookupCookie: 'i18next', // Cookie: i18next=sv
        cookieMinutes: 10080, // 7 days cookie expiration
        lookupLocalStorage: 'i18nextLng', // localStorage.i18nextLng=sv
        lookupSessionStorage: 'i18nextLng', // sessionStorage.i18nextLng=sv
      },
      react: {
        useSuspense: false,
      },
    });

  return i18n;
};

export default initI18n;
